import { atom } from 'recoil';
import { ConsultationViewTypes } from '../../types';

export const searchViewTypeState = atom<number>({
  key: 'searchViewType',
  default: ConsultationViewTypes.Open,
});
